export const AppointmentRow = {
  display: 'grid',
  gridTemplateColumns: '70px 1fr 1fr 1fr 100px',
  align: 'center flex-start',
  padding: 'Z A',
  borderBottom: '1px solid inkBorder',
  cursor: 'pointer',
  transition: 'background 0.15s ease',
  ':hover': { background: 'inkSurface' },
  ':last-child': { borderBottom: 'none' },
  '@mobileL': { display: 'flex', flow: 'y', gap: 'Y' },
  onClick: (e, el, s) => {
    s.root.update({
      selectedAppointment: {
        patient: s.patient,
        time: s.time,
        service: s.service,
        doctor: s.doctor,
        status: s.status
      },
      showAppointmentModal: true
    })
  },
  TimeCell: {
    text: (el, s) => s.time,
    fontSize: 'Z',
    color: 'inkMuted',
    fontWeight: '500'
  },
  PatientCell: {
    extends: 'Link',
    href: '/patient',
    text: (el, s) => s.patient,
    fontSize: 'Z',
    color: 'teal',
    fontWeight: '600',
    textDecoration: 'none',
    ':hover': { textDecoration: 'underline' },
    onClick: (e, el, s) => {
      e.stopPropagation()
    }
  },
  ServiceCell: { text: (el, s) => s.service, fontSize: 'Z', color: 'inkMuted' },
  DoctorCell: { text: (el, s) => s.doctor, fontSize: 'Z', color: 'inkMuted' },
  StatusWrap: { textAlign: 'right', StatusCell: { extends: 'StatusBadge' } }
}
